import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const ColumnLabel = styled.div`
	display: block;
	font-family: ${({ theme }) => helpers.font.family.header};
`
